export const GET_USER = "USER"
export const GET_USER_SUCCESS = "GET_USER_SUCCESS"
export const GET_USER_ERROR = "GET_USER_ERROR"

export const REMOVE_USER = "REMOVE_USER";
export const SET_MUTED = "SET_MUTED"

export const USER_UPDATED = "USER_UPDATED" 
export const AVATAR_UPDATED = "AVATAR_UPDATED"